import Vue from 'vue';

export function registerApp(selector, component, options = {}) {
    const el = document.querySelector(selector);

    if (!el) return;

    const app = new Vue({
        provide: { options },
        render: (h) => h(component)
    });

    return app.$mount(selector);
}
